import * as React from 'react'
import { inject, observer } from 'mobx-react'
import { CurrentCompanyStore } from '../stores/CurrentCompanyStore'

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  secureImageFileName?: string | null
}

interface State {
  url?: string
  isLoading?: boolean
}

@inject('currentCompanyStore')
@observer
export class SecureImage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isLoading: false,
      url: undefined,
    }
  }

  componentDidMount() {
    const secureImageFileName = this.props.secureImageFileName
    if (secureImageFileName) {
      this.loadImage(secureImageFileName)
    }
  }

  UNSAFE_componentWillReceiveProps(props: Props) {
    if (props.secureImageFileName && props.secureImageFileName !== this.props.secureImageFileName) {
      this.loadImage(props.secureImageFileName)
    }
  }

  loadImage(secureFileName: string) {
    if (secureFileName) {
      this.setState({ isLoading: true })
      this.props
        .currentCompanyStore!.getSignedImageUrl(secureFileName)
        .then((signedUrlObject) => {
          const url = signedUrlObject.signedUrl
          this.setState({
            isLoading: false,
            url: url,
          })
        })
        .catch(() => {
          this.setState({
            isLoading: false,
          })
        })
    }
  }

  render() {
    if (!this.props.secureImageFileName) {
      return <span />
    } else if (this.state.isLoading) {
      return <span>Loading secure image...</span>
    } else {
      return <img style={{ width: '100%' }} src={this.state.url} />
    }
  }
}
